import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import PlanDetailsDialog from './plan-details-dialog.vue';
import { logger } from '@/utils/log';

export default {
  data() {
    return {
      planDetailsDialog: null
    }
  },
  created() {
    this.planDetailsDialog = new ServiceConfirm(PlanDetailsDialog);
  },
  methods: {
    async showPlanDetailDialog() {
      try {
        this.$tracking.buyInteraction('plan details selected', this.trackingPlanName)
        await this.planDetailsDialog.confirm({
          title: this.title,
          trackingPlanName: this.trackingPlanName,
          planCategory: this.currentPlanBasicInfo?.category,
        });
      } catch (error) {
        logger.warn('Failed to show plan detail dialog or hidden the dialog', error);
        return null;
      }
    },
  },
};
